function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Platform } from 'react-native';
import { ScrollView, Stack, View, SizableText, useTheme, useThemeName } from 'tamagui';
import { Flex } from 'components/base/General';
import CardCarousel from 'components/cards/CardCarousel';
import { HeaderText } from 'components/utility/General';
import { Link } from 'solito/link';
import { ArrowRightButton } from 'app/components/utility/General';
const CategoryChild = props => {
  const theme = useTheme();
  const colorMode = useThemeName();
  const color = colorMode === 'light' ? 'black' : 'white';
  return /*#__PURE__*/React.createElement(Stack, {
    ml: 8,
    my: 25,
    height: 50,
    maxWidth: 325,
    justifyContent: "center"
  }, props.url ? /*#__PURE__*/React.createElement(Link, {
    href: '/' + props.url
  }, /*#__PURE__*/React.createElement(Stack, {
    flexDirection: "row",
    alignItems: "center",
    gap: 20,
    hoverStyle: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement(Stack, null, /*#__PURE__*/React.createElement(HeaderText, {
    headerLevel: 2,
    fontWeight: "bold",
    fontSize: "$3xl",
    textTransform: "uppercase",
    textDecorationLine: "underline",
    userSelect: "none",
    color: theme.mainColor.get()
  }, props.category)), /*#__PURE__*/React.createElement(ArrowRightButton, {
    color: color
  }))) : /*#__PURE__*/React.createElement(SizableText, {
    fontWeight: "bold",
    fontSize: "$3xl",
    textTransform: "uppercase",
    textDecorationLine: "underline",
    color: theme.mainColor.get()
  }, props.category));
};
const Category = CategoryChild;
const CardRow = props => {
  const {
    articleGroup,
    overrideCategory
  } = props;
  if (!articleGroup || !articleGroup.data) {
    return /*#__PURE__*/React.createElement(Stack, null, /*#__PURE__*/React.createElement(SizableText, null, "Error loading articles. Please try again later."));
  }
  const groupLength = articleGroup.data.length;
  if (groupLength === 0) {
    return /*#__PURE__*/React.createElement(Stack, null);
  }
  return /*#__PURE__*/React.createElement(Stack, {
    mx: 0
  }, overrideCategory ? /*#__PURE__*/React.createElement(Category, {
    category: 'Recent Articles'
  }) : /*#__PURE__*/React.createElement(Category, {
    category: articleGroup.category,
    url: articleGroup.url
  }), Platform.OS === 'web' ? /*#__PURE__*/React.createElement(CardRowWeb, _extends({}, props, {
    groupLength: groupLength
  })) : /*#__PURE__*/React.createElement(CardRowNative, _extends({}, props, {
    groupLength: groupLength
  })));
};
const CardRowWeb = props => {
  return /*#__PURE__*/React.createElement(CardCarousel, props);
};
const CardRowNative = props => {
  return /*#__PURE__*/React.createElement(CardCarousel, props);
};
export default CardRow;